/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import type { ComponentLike, ContentValue } from '@glint/template';

import type { BvBtnArgs } from '../bv-btn';
import type { SafeString } from '@ember/template';

export interface ILabelAction extends BvBtnArgs {
  icon?: string;
}

export interface BvLabelledSignature {
  Args: {
    action?: ILabelAction;
    class?: string;
    dataTestLabelled?: string;
    error?: TFieldError;
    fullWidth?: boolean;
    helpText?: string;
    id?: string;
    info?: ContentValue | ComponentLike;
    inline?: boolean;
    isEdited?: boolean;
    label?: string | SafeString;
    labelHidden?: boolean;
    labelWrapperClass?: string;
    isRequired?: boolean;
    warning?: TFieldError;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default class BvLabelledComponent extends Component<BvLabelledSignature> {
  get warningMessage() {
    const { warning } = this.args;
    if (Array.isArray(warning)) {
      return undefined;
    }
    return warning as ContentValue;
  }

  get warningMessages() {
    const { warning } = this.args;
    if (Array.isArray(warning)) {
      return warning as ContentValue[];
    }
    return undefined;
  }

  get errorMessage() {
    const { error } = this.args;
    if (Array.isArray(error) || typeof error === 'boolean') {
      return undefined;
    }
    return error as ContentValue;
  }

  get errorMessages() {
    const { error } = this.args;
    if (error && Array.isArray(error)) {
      return error as ContentValue[];
    }
    return undefined;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvLabelled: typeof BvLabelledComponent;
    'bv-labelled': typeof BvLabelledComponent;
  }
}
